module.exports = __webpack_public_path__ + "static/media/flp.d1f85c5e.png";